import axiosInstance from "api/axiosInstance";
export const transaction = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/transactions/list", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const getFinancialLogs = async (accessToken) => {
  try {
    const response = await axiosInstance.get(
      "/admin/transactions/financial-logs",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;

      if (status === 403) {
        console.warn("خطای 403: دسترسی غیرمجاز");
        window.location.href = "/login";
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message ||
          "خطا در دریافت گزارش‌های مالی",
      };
    }

    throw {
      statusCode: 500,
      message: "مشکل شبکه یا عدم دسترسی به سرور",
    };
  }
};
export const transactionEdit = async ({ accessToken, id, status }) => {
  try {
    const response = await axiosInstance.patch("/admin/transactions/edit", { id, status }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const getOnesubscription = async ({ accessToken, id }) => {
  try {
    const response = await axiosInstance.get('/admin/subscriptions/search', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        id
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};